import {message, Upload} from "antd";

export const beforeUpload = (file: any, accept = '.jpg,.png,.jpeg', maxSize = 5) => {
  const MAX_SIZE = maxSize * 1024 * 1024;
  const acceptArr = accept.split(',');

  if ((file.type || '').startsWith('image')) {
    console.log(file)
    const hasNotAllowType = acceptArr.every(type => !file.name.endsWith(type))
    if (hasNotAllowType) {
      message.error(`图片必须是${accept}格式`, 6)
      return Upload.LIST_IGNORE
    }
    const isLimitSize = file.size <= MAX_SIZE;
    if (!isLimitSize) {
      message.error(`图片大小不能超过 ${maxSize}MB`);
      return Upload.LIST_IGNORE;
    }
    return true
  }
  message.error('只能上传图片')
  return Upload.LIST_IGNORE
}

export function getNumberUnit(num, defaultUnit = '个', toFixed) {
  let value = num || 0;
  let unit = defaultUnit;
  let state = false;
  if (value < 0) {
    value = value + (-value * 2)
    state = true
  }
  if (value > 10000 && value < 100000000) {
    value = value / 10000;
    unit = '万';
  }
  if (value >= 100000000) {
    value = value / 100000000;
    unit = '亿';
  }
  if (toFixed > 0) {
    value = parseFloat(value).toFixed(toFixed)
    const str = value?.split('.')[1].split("")
    const status = str.every(d => d == 0)
    if (status) {
      value = value?.split('.')[0]
    }
  } else {
    value = ~~value
  }
  if (state) value = -value
  return {
    value,
    unit,
    numberValue: value + unit
  };
}